export const theme = {
  fonts: {
    montserrat: "'Montserrat', sans-serif",
    badScript: "'Bad Script', sans-sarif",
  },
  linearGradient: {
    gray: "linear-gradient(45deg, #f0f0f0, #929292)",
    lightGray: "linear-gradient(45deg, #f0f0f0, #cecece)",
    brown: "linear-gradient(45deg, #af6600, #787878)",
  },
  color: {
    darkGray: "#262637",
    lightGray: "rgba(51, 51, 51, 0.7)",
    accent: "rgba(0, 60, 103, 0.6)",
    light: "#fff",
  },
  border: {
    sm: "0.5px solid",
    md: "3px solid",
  },
  shadow: {
    textShadow:
      "0px 3px 0px #b2a98f, 0px 14px 10px rgba(0, 0, 0, 0.15), 0px 24px 2px rgba(0, 0, 0, 0.1), 0px 34px 30px rgba(0, 0, 0, 0.1)",
    boxShadow: "rgba(33, 35, 38, 0.2) 0 10px 10px -5px",
  },
  breakpoints: {
    lg: "1280px",
    md: "768px",
    sm: "567px",
    xs: "320px",
  },
};
